"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MESSAGE_LABELS = void 0;
var MESSAGE_LABELS = {
  MARK_AS_READ: "Mark as Read",
  MARK_AS_UNREAD: "Mark as Unread",
  ARCHIVE_MESSAGE: "Archive"
};
exports.MESSAGE_LABELS = MESSAGE_LABELS;